<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-8
        router-link.button-previous.mr-2(:to="{path: '/administracion/id/guideline-list', query: {restart: false}}")
          i.fas.fa-chevron-left
        h1.m-0.d-inline-block.align-middle
          i Editar Conducta
      .col-4
        .h2.text-right.ad_text-grayLight.m-0
          i.text-capitalize
    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col-12
          .card.p-0.ad_bg-gray.rounded-xl
            .card-body
              form.d-flex.flex-row.flex-wrap
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Conducta
                  textarea.col.form-control(type="text" v-model="evaluation" rows="3" placeholder='ingresa competencia' title='ingresa tu nombre')
                .col.row.align-items-start
                  label.col.pl-0.m-0 Competencia
                  .col.px-0.ad_select
                    select(v-model='categoryextSelected')
                      option(:value="null" disabled) Selecciona Competencia
                      option(:value="c" v-for="c in categoryexts", :key="c._id") {{c.name}}
                .col-6.form-group.align-items-center.mb-4
                  label.col-3.pl-0.m-0 Indice
                  input.col.form-control(type="number" v-model="index" maxlength='100' placeholder='0' max="100" title='Meta')

          .d-flex.flex-row.mt-5
            router-link.stepper-button.previous(to="/administracion/id/guideline-list")
              i.material-icons
              span Volver
            button.col-auto.stepper-button.next.ml-auto(@click="updateGuidelineManager()")
              span Actualizar
              i.material-icons


</template>

<script>
import { mapActions } from 'vuex';
import { nullLiteralTypeAnnotation } from 'babel-types';
export default {
  name: 'GuidelineEdit',
  data () {
    return {
      guideline: null,
      evaluation: null,
      categoryexts: [],
      index: null,
      categoryextSelected: null
    }
  },
  methods: {
    ...mapActions('categoryext', [
      'categoryExtList'
    ]),
    ...mapActions('guideline', [
      'getGuidelineById', 'updateGuideline'
    ]),
    setGuidelineProps() {      
      const vm = this      
      try {
        vm.evaluation = vm.guideline.evaluation
        vm.categoryextSelected = vm.guideline.categoryext
        vm.index = vm.guideline.index
      } catch (e) {
        vm.notify(e)
        console.info(e)
      }
    },
    getGuidelineFromProps() {
      const vm = this
      return {
        id: vm.guideline._id,
        evaluation: vm.evaluation,
        categoryext: vm.categoryextSelected,
        index: vm.index
      }
    },
    getCategoryExts() {
      const vm = this
      vm.categoryExtList().then(response => {
        vm.categoryexts = response;
      })
    },
    loadDetail(id) {
      const vm = this
      const loading = vm.$toast.loading('Cargando Detalle...')      
      vm.getGuidelineById(id).then((scalevalue) => {
        vm.guideline = vm.$store.getters['guideline/getGuideline'];
        vm.setGuidelineProps()
        loading.hide()
      }).catch(error => {
        vm.notify(error)
        loading.hide()
      })
    },
    notify(error = true, message) {
      const vm = this
      vm.$notify({
          type: error ? 'danger' : 'success',
          title: 'Notificación',
          content: message,
          closeable: true,
          duration: 5000
        })
    },
    updateGuidelineManager() {
      const vm = this
      const loading = vm.$toast.loading('Guardando...')
      if (vm.validate()) {
        const data = vm.getGuidelineFromProps()
        vm.updateGuideline(data).then(result => {
          if (!result.success) {
            loading.hide()
            vm.notify(true, result.message)
          } else {
            loading.hide()
            vm.notify(false, 'Escala actualizado')
          }
        }).catch(error => {
          loading.hide()
          vm.notify(true, error.payload.message)
        })
        loading.hide()
      } else {
        loading.hide()
      }
    },
    isValidInput(input) {
      return input !== undefined && input !== null
    },
    isValidInputPer(input) {
      return input >= 0 && input <= 100
    },
    isValidBoolean(input) {
      return input === false || input === true
    },
    validate() {
      const vm = this
      let valid = true
      let missing = ''
      if (!vm.isValidInput(vm.evaluation)) {
        missing = 'Debe completar el campo Conducta'
        valid = false
      } else if (!vm.isValidInput(vm.categoryextSelected)) {
        missing = 'Debe completar el campo Competencia'
        valid = false
      } else if (!vm.isValidInputPer(vm.index)) {
        missing = 'Debe completar el campo indice'
        valid = false
      }

      if (valid) {
        return true
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: missing,
          closeable: true,
          duration: 5000
        })
        return false
      }
    }
  },
  mounted() {
    const vm = this;
    vm.getCategoryExts();
    vm.loadDetail(this.$route.params.id)
    this.$emit('can-continue', { value: true })
  }
}
</script>

<style lang="css" scoped></style>


// WEBPACK FOOTER //
// src/views/guideline/guideline-edit.vue